<div class="ofwca-to-reassign-list" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px" *ngIf="!disableModificationSwitch && !disableModification">
    <button
      *ngIf="!modify"
      [disabled]="!(userPermissions | async).contract.create"
      (click)="modify = true" mat-stroked-button color="primary"
    ><mat-icon>create</mat-icon> <span> Edytuj</span></button>

    <button *ngIf="modify" (click)="endModification()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Zakończ</span></button>
  </div>

  <div fxLayout="column" fxFlex="100">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="ofwca">
        <th mat-header-cell *matHeaderCellDef> OFWCA </th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">
            {{element.ofwca.firstName}} {{element.ofwca.lastName}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status</th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button [ngClass]="element.ofwca.status.color + '-button'">{{element.ofwca.status.name}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="currentFacility">
        <th mat-header-cell *matHeaderCellDef> Aktualna placówka</th>
        <td mat-cell *matCellDef="let element">
          <app-table-address *ngIf="element.ofwca.facility" [address]="element.ofwca.facility.address"></app-table-address>
        </td>
      </ng-container>

      <ng-container matColumnDef="partner">
        <th mat-header-cell *matHeaderCellDef> Partner </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!modify">
            <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.ofwcaReassign?.newPartner?.uuid]">
              {{element.ofwcaReassign?.newPartner?.shortName}}
            </a>
          </ng-container>

          <div class="ofwca-to-reassign-select" *ngIf="modify">
            <app-dict-partners [control]="element.form.get('newPartner')"></app-dict-partners>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="contract">
        <th mat-header-cell *matHeaderCellDef> Umowa </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!modify">
            <a class="default-link" [routerLink]="['/umowy/szczegoly', element.ofwcaReassign?.newContract?.uuid]">
              {{element.ofwcaReassign?.newContract?.number}}
            </a>
          </ng-container>
          <div class="ofwca-to-reassign-select" *ngIf="modify">
            <app-dict-contracts
              *ngIf="element.form.get('newPartner').value"
              [partnerId]="element.form.get('newPartner').valueChanges"
              [control]="element.form.get('newContract')"
              [initializeWith]="element.form.get('newPartner').value"
              [companyId]="contractObject.company.id"
            ></app-dict-contracts>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="facility">
        <th mat-header-cell *matHeaderCellDef> Placówka </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="!modify">
            <a class="default-link"
               [routerLink]="['/placowki/szczegoly', element.ofwcaReassign?.newPartnerFacility?.address?.uuid]"
            >
              {{element.ofwcaReassign?.newPartnerFacility?.address?.searchString}}
            </a>
          </ng-container>

          <div class="ofwca-to-reassign-select" *ngIf="modify">
            <app-partner-facility-select
              *ngIf="element.form.get('newPartner').value"
              [partnerId]="element.form.get('newPartner').valueChanges"
              [control]="element.form.get('newPartnerFacility')"
              [initializeWith]="element.form.get('newPartner').value"
            ></app-partner-facility-select>
          </div>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
  </div>

</div>
